<template>
  <div class="data-grid-popover">
    <AsyncComponent v-if="componentPath"
                    :component-path="componentPath"
                    v-bind="popoverAttrs"
                    v-on="$listeners"></AsyncComponent>
  </div>
</template>

<script>
import AsyncComponent from '../async/AsyncComponent'
export default {
  name: 'DataGridPopover',
  components: {
    AsyncComponent
  },
  props: {
    componentPath: {
      type: String,
      required: true
    },
    popoverExtra: {
      type: Object
    }
  },
  computed: {
    popoverAttrs () {
      return this.$extend(this.$attrs, this.popoverExtra)
    }
  }
}
</script>

<style lang="scss">
  .data-grid-popover {
    height: 100%;
  }
</style>
